import React, {useEffect} from "react";

import Layer1 from "../layers/Layer1"
import Layer2 from "../layers/Layer2"
import AddVariable from "../layers/Layer3/AddVariable"
import Layer4 from "../layers/Layer4"
import { useParams } from 'react-router-dom'
import useGlobal from "../store";

import "./index.scss";
import { buildingById, equipmentById, siteById, spaceById, featureById } from "../services/MetadataService";

const VariableAdd = () => {
    let [currentState, currentActions] = useGlobal();
    const { context, id } = useParams()
    
    useEffect(() => {
        if (context === "equipment") {
            equipmentById(id).then(response => {
                currentActions.setEquipment(response)
            })
        } else if (context === "feature") {
            featureById(id).then(response => {
                currentActions.setFeature(response)
                currentActions.setSpace(response.space)
                currentActions.setBuilding(response.space.floor.building)
                currentActions.setSite(response.space.floor.building.site)
            })
        } else if (context === "space") {
            spaceById(id).then(response => {
                currentActions.setSpace(response)
                buildingById(response.building_id).then(response => {
                    currentActions.setBuilding(response)
                    currentActions.setSite(response.site)
                })
            })
        } else if (context === "building") {
            buildingById(id).then(response => {

                currentActions.setBuilding(response)
                currentActions.setSite(response.site)
            })
        } else if (context === "site") {
            siteById(id).then(response => {
                currentActions.setSite(response)
            })
        }
    }, [])
    return  (
        <div className="ui-main location">
            <Layer1 />
            <Layer2 submodule="Variables" context={context} />
            <AddVariable context={context}  id={id} />
            <Layer4 />
        </div>
    )
}

export default VariableAdd